// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ element, ...rest }) => {
    const token = useSelector((state) => state.auth.token); 

    return (
        token ? element : <Navigate to="/loginadmin" />
    );
};

export default PrivateRoute;
